import { useLocation } from "react-router-dom";
import { SITE } from "../data/site";
import { trackEvent } from "../lib/track";

export const PhoneLink = ({ placement, className = "", children }) => {
  const { pathname } = useLocation();
  return (
    <a
      href={SITE.phoneHref}
      data-testid={`${placement}-phone-link`}
      aria-label={`Call ${SITE.phoneDisplay}`}
      onClick={() => trackEvent("call", pathname, placement)}
      className={className}
    >
      {children ?? SITE.phoneDisplay}
    </a>
  );
};

export const TextLink = ({ placement, className = "", children }) => {
  const { pathname } = useLocation();
  return (
    <a
      href={SITE.smsHref}
      data-testid={`${placement}-text-link`}
      aria-label={`Text ${SITE.phoneDisplay}`}
      onClick={() => trackEvent("text", pathname, placement)}
      className={className}
    >
      {children ?? "Text us"}
    </a>
  );
};
